import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'orderArrayBy'
})
export class OrderArrayByPipe implements PipeTransform {

  goDeepValue(obj: any, desc): any {
    const arr = desc.split('.');
    // tslint:disable-next-line:no-conditional-assignment
    while (arr.length && (obj = obj[arr.shift()])) {
    }
    return obj;
  }
  transform(array: any[], property: string, order: 'asc' | 'desc'): any[] {
    if (array == null) {
      return null;
    }
    array.sort((a: any, b: any) => {
      const aValue = this.goDeepValue(a, property);
      const bValue = this.goDeepValue(b, property);
      if (aValue < bValue ){
        return -1;
      }else if ( aValue > bValue){
        return 1;
      }else{
        return 0;
      }
    });
    return array;
  }
}
